import ProductItem from '../components/product/ProductItem';
import { unitlessBreakpoints } from '../helpers';
import initCarousel from '../helpers/carousel';

const selectors = {
  productItem: '[data-product-item]',
  dot: '[data-shop-the-look-dot]',
};

export default class DynamicShopTheLook {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.init();
  }

  init() {
    this.splide = initCarousel(this.el, {
      perPage: 1,
      gap: '0.5rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          padding: {
            right: '30%'
          }
        },
        [unitlessBreakpoints.md]: {
          padding: {
            right: 0
          }
        },
        [unitlessBreakpoints.lg]: {
          perPage: 2,
        },
      },
    });

    const productItems = this.el.querySelectorAll(selectors.productItem);
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    this.dots = [...this.el.querySelectorAll(selectors.dot)];
    this._bindDots();
    this._bindCarouselActiveState();
  }

  _bindDots() {
    if (!this.splide || !this.dots.length) return;

    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.shopTheLookIndex || 0);
        this.splide.go(index);
        this._setActive(index);
      });
    });
  }

  _bindCarouselActiveState() {
    if (!this.splide) return;

    this.splide.on('mounted', () => {
      this._setActive(this.splide.index || 0);
    });

    this.splide.on('move', newIndex => {
      this._setActive(newIndex);
    });
  }

  _setActive(index) {
    if (!this.splide) return;

    // Active dot
    if (this.dots && this.dots.length) {
      this.dots.forEach(dot => {
        const dotIndex = Number(dot.dataset.shopTheLookIndex || 0);
        const isActive = dotIndex === index;
        dot.classList.toggle('text-white', !isActive);
        dot.classList.toggle('text-black', isActive);
        dot.classList.toggle('border-white', !isActive);
        dot.classList.toggle('border-black', isActive);
        dot.classList.toggle('bg-black', !isActive);
        dot.classList.toggle('bg-white', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    }

    // Active slide (border highlight)
    const slides = this.el.querySelectorAll('.splide__slide');
    [...slides].forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('md:border-grey-3', isActive);
      slide.classList.toggle('md:border-transparent', !isActive);
    });
  }

  onSectionUnload() {
    // No cleanup needed currently
  }
}
